import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'components/ui/select';
import { RenoMessageType } from '../types/renoTicket';

/**
 * Keuzelijst "waarover gaat deze mail" (Offerte, Factuur, …).
 *
 * Staat naast de verzendknop van een renovatieticket: het type wordt **per mail**
 * bewaard, want het tickettype kan later nog wijzigen en zegt dan niets meer over een
 * eerder verstuurde mail. Voorgevuld met het tickettype, aanpasbaar per mail.
 *
 * `none` is de waarde voor "geen type": Radix aanvaardt geen lege string als
 * `SelectItem`-waarde.
 */
const GEEN_TYPE = 'none';

interface Props {
  value: RenoMessageType | null;
  onChange: (value: RenoMessageType | null) => void;
  disabled?: boolean;
}

export function RenoMessageTypeSelect({ value, onChange, disabled }: Props) {
  return (
    <Select
      value={value ?? GEEN_TYPE}
      onValueChange={(v) => onChange(v === GEEN_TYPE ? null : (v as RenoMessageType))}
      disabled={disabled}
    >
      <SelectTrigger
        className="h-7 w-[170px] text-xs"
        title="Waarover gaat deze mail? Wordt per mail bewaard en in het e-mailoverzicht getoond."
      >
        <SelectValue placeholder="Type mail" />
      </SelectTrigger>
      {/* popper + vaste max-hoogte: anders verschuift de pagina bij het openen (zie CLAUDE.md
          § Radix/shadcn Select). `modal` bestaat niet op Select — enkel op Dropdown/Popover. */}
      <SelectContent position="popper" sideOffset={4} align="start" className="max-h-[200px]">
        <SelectItem value={GEEN_TYPE} className="text-xs">
          Geen type
        </SelectItem>
        {Object.values(RenoMessageType).map((type) => (
          <SelectItem key={type} value={type} className="text-xs">
            {type}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
